/**
 * @description 系统全局配置
 */
export default {
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000,
  /**
   * @description 后端请求地址
   */
  base_url: process.env.NODE_ENV === 'production' ? 'https://onecardok.com.cn/site' : 'http://localhost:8080/site',
  /**
   * @description 网站标题
   */
  site_title: '新中新二代证阅读器'
}
